


























import { Component, Prop, Vue } from "vue-property-decorator";
import DialogBox from "@/components/dialog-box/DialogBox.vue";

@Component({
    components: { DialogBox }
})
export default class OutOfStockDialogWithCheckbox extends Vue {
    @Prop({ default: false }) isDialogOpen: boolean;
    @Prop({ default: "Confirmer cette action" }) title: string;
    @Prop({ default: [] }) propositions: string[];

    selectedPropositions: string[] = [];

  stockOut() {
        this.emitAndReset("stockOut", this.selectedPropositions);
    }

    continueOrder() {
      this.emitAndReset("continueOrder");
    }

    cancel() {
        this.emitAndReset("cancel");
    }

    private emitAndReset(eventName: string, payload?: string[]): void {
        this.$emit(eventName, payload);
        this.selectedPropositions = [];
    }

    get canStockOut(): boolean {
        return this.selectedPropositions.length > 0;
    }
}
